module.exports = __webpack_public_path__ + "img/kbo_player_rank_img_default_thum.234024ac.svg";